<section class="flex flex-row h-full">
  <header class="header flex flex-col text-right">
    <ng-container *ngFor="let step of _steps; let i = index">
      <div
        *ngIf="step.isNormalStep && !step.hidden"
        [ngClass]="selected === step ? activeClass : ''"
        class="step py-2 pl-2 pr-4 cursor-pointer"
        (click)="step.select()">
        <div
          [ngClass]="selected === step ? activeClass + '-content' : ''"
          class="pl-2 w-full flex flex-row justify-end items-center">
          <ng-container
            *ngTemplateOutlet="
              stepLabel;
              context: { $implicit: step }
            "></ng-container>
          <ng-container
            *ngTemplateOutlet="
              check;
              context: { $implicit: step }
            "></ng-container>
        </div>
      </div>
      <div
        *ngIf="step.isHeader && !step.hidden"
        class="stepHeader py-3 pl-4 pr-8 flex flex-row justify-end items-center">
        <ng-container
          *ngTemplateOutlet="
            stepLabel;
            context: { $implicit: step }
          "></ng-container>
      </div>
      <div
        *ngIf="step.isParent && !step.hidden"
        class="step parentStep py-2 pl-4 pr-2 flex flex-row justify-between items-center cursor-pointer border-b"
        (click)="step.toggleShowChildren()">
        <mat-icon *ngIf="step._childrenHidden">keyboard_arrow_right</mat-icon>
        <mat-icon *ngIf="!step._childrenHidden">keyboard_arrow_down</mat-icon>
        <div class="pl-2 w-full flex flex-row justify-end items-center">
          <ng-container
            *ngTemplateOutlet="
              stepLabel;
              context: { $implicit: step }
            "></ng-container>
          <ng-container
            *ngTemplateOutlet="
              check;
              context: { $implicit: step }
            "></ng-container>
        </div>
      </div>
      <div
        *ngIf="step.isSubstep && !step.hidden"
        [ngClass]="selected === step ? activeClass : ''"
        class="step py-2 pl-2 pr-4 cursor-pointer substep text-sm"
        (click)="step.select()">
        <div
          [ngClass]="selected === step ? activeClass + '-content' : ''"
          class="pl-2 w-full flex flex-row justify-end items-center">
          <ng-container
            *ngTemplateOutlet="
              stepLabel;
              context: { $implicit: step }
            "></ng-container>
          <ng-container
            *ngTemplateOutlet="
              check;
              context: { $implicit: step }
            "></ng-container>
        </div>
      </div>
      <div *ngIf="step.isButton && !step.hidden" class="py-2 px-8">
        <button
          mat-flat-button
          color="primary"
          class="w-full"
          [disabled]="step.disabled"
          (click)="step.buttonClick.emit($event)"
          [matTooltip]="step.tooltip"
          matTooltipPosition="right">
          <ng-container
            *ngTemplateOutlet="
              stepLabel;
              context: { $implicit: step }
            "></ng-container>
        </button>
      </div>
    </ng-container>
  </header>
  <div class="w-full h-full overflow-y-auto relative">
    <div [class]="containerClass">
      <ng-container [ngTemplateOutlet]="selected.content"></ng-container>
      <div class="flex flex-row justify-between gap-4 pb-20 w-full">
        <div>
          <button
            mat-flat-button
            color="primary"
            *ngIf="hasPrevious()"
            (click)="previous()">
            {{ selected.previousButtonText || "BACK" }}
          </button>
        </div>
        <div>
          <button
            mat-flat-button
            color="primary"
            [disabled]="
              linear && selected.stepControl
                ? selected.stepControl.invalid
                : false
            "
            *ngIf="hasNext()"
            (click)="next()">
            {{ selected.nextButtonText || "NEXT" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #stepLabel let-step>
  <ng-container
    *ngIf="step.stepLabel; else showLabelText"
    [ngTemplateOutlet]="step.stepLabel.template">
  </ng-container>
  <ng-template #showLabelText>
    {{ step.label }}
  </ng-template>
</ng-template>

<ng-template #check let-step>
  <div class="flex ml-2 w-4 h-4">
    <div
      class="check rounded-full w-4 h-4"
      [hidden]="!step.completed || step.isAdder">
      <mat-icon
        class="text-white scale-50 -translate-x-1 -translate-y-1 transform"
        >check</mat-icon
      >
    </div>
  </div>
</ng-template>
